import { atom } from 'recoil';
import { PrivateOrganizationInfo } from '@/types/api/mypage/privateOrganizationInfoReportList';
import persistAtom from './recoilPersist';

/**
 * 任意団体情報一覧を保持する state。
 * 活動報告書一覧や関連導線で、取得済みの団体情報を再利用するために保持する。
 */
export const PrivateOrganizationInfoReportListState = atom<PrivateOrganizationInfo[]>({
  key: 'PrivateOrganizationInfoReportListState',
  default: [],
  effects_UNSTABLE: [persistAtom],
});

export default PrivateOrganizationInfoReportListState;
